import React, { useState } from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { X } from 'lucide-react';

const Gallery = () => {
    const [selectedImage, setSelectedImage] = useState(null);

    const galleryImages = [
    {
      src: "/assets/store-front-1.jpeg",
      alt: "Dhakad Enterprises Store Front",
    },
    {
      src: "/assets/supremo-pipes-tubs.jpeg",
      alt: "Supremo Pipes & Tubs",
    },
    // {
    //   src: "/assets/store-steel-rods.jpeg",
    //   alt: "Dhakad Enterprises Store with Steel Rods",
    // },
    // {
    //   src: "/assets/mycem-counter.jpeg",
    //   alt: "Mycem Cement Counter",
    // },
    {
      src: "/assets/steel-rods-cement-bags.jpeg",
      alt: "Steel Rods & Cement Bags",
    },
    // {
    //   src: "/assets/store-exterior.jpeg",
    //   alt: "Dhakad Enterprises Exterior",
    // },
    {
      src: "/assets/warehouse-interior.jpeg",
      alt: "Warehouse Interior",
    },
    // {
    //   src: "/assets/tmt-bars-bundles.jpeg",
    //   alt: "TMT Bars Bundles",
    // },
    // {
    //   src: "/assets/kamdhenu-steel-rods.jpeg",
    //   alt: "Kamdhenu Steel Rods",
    // },
    {
      src: "/assets/bansal-steel-rods.jpeg",
      alt: "Bansal Steel Rods",
    },
    // {
    //     src: '/assets/store-front-2.jpeg',
    //     alt: 'Dhakad Enterprises Store'
    // },
    {
      src: "/assets/mycem-desk.jpeg",
      alt: "Mycem Cement Desk",
    },
    // {
    //   src: "/assets/perfect-plus-cement.jpeg",
    //   alt: "Perfect Plus Cement Bags",
    // },
    // {
    //   src: "/assets/wonder-cement-1.jpeg",
    //   alt: "Wonder Cement Bags",
    // },
    // {
    //     src: '/assets/wonder-cement-2.jpeg',
    //     alt: 'Wonder Cement Storage'
    // },
    {
      src: "/assets/mycem-primo-cement.jpeg",
      alt: "Mycem Primo Cement",
    },
    // {
    //   src: "/assets/cement-bags-storage.jpeg",
    //   alt: "Cement Bags Storage",
    // },
    {
      src: "/assets/steel-wire-coils.jpeg",
      alt: "Steel Wire Coils",
    },
    // {
    //     src: '/assets/warehouse-wide-view.jpeg',
    //     alt: 'Warehouse Wide View'
    // },
    // {
    //     src: '/assets/steel-rods-warehouse.jpeg',
    //     alt: 'Steel Rods in Warehouse'
    // },
    {
        src: '/assets/steel-bars-wide-view.jpeg',
        alt: 'Steel Bars Wide View'
    },
    {
      src: "/assets/construction-sand.jpeg",
      alt: "Construction Sand",
    },

    // {
    //     src: '/assets/water-tank-fixit.jpeg',
    //     alt: 'Water Tank & Dr. Fixit Products'
    // },
    // {
    //     src: '/assets/perfect-plus-cement-2.jpeg',
    //     alt: 'Perfect Plus Cement'
    // },
    {
      src: "/assets/wonder-cement-bulk.jpeg",
      alt: "Wonder Cement Bulk Storage",
    },
  ];

    return (
        <section id="gallery" className="py-20 lg:py-28 bg-background">
            <div className="section-container">
                {/* Section Header */}
                <div className="text-center mb-16">
                    <p className="text-primary font-medium text-sm uppercase tracking-wider mb-3">
                        Dhakad Enterprises
                    </p>
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground section-title">
                        Our Gallery
                    </h2>
                    <p className="text-muted-foreground mt-6 max-w-2xl mx-auto">
                        Explore our collection of images showcasing the high-quality construction materials 
                        we offer and the successful projects we've contributed to.
                    </p>
                </div>

                {/* Gallery Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-6">
                    {galleryImages.map((image, index) => (
                        <div
                            key={index}
                            className={`gallery-item cursor-pointer rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300
                                ${index === 0 ? 'sm:col-span-2 sm:row-span-2 md:col-span-2 md:row-span-3' : ''}
                            `}
                            onClick={() => setSelectedImage(image)}
                        >
                            <img
                                src={image.src}
                                alt={image.alt}
                                className={`w-full object-cover transition-transform duration-500 hover:scale-110
                                    ${index === 0 ? 'h-48 sm:h-full md:h-full' : 'h-48 sm:h-44 lg:h-56'}
                                `}
                            />
                        </div>
                    ))}
                </div>
            </div>

            {/* Image Modal */}
            <Dialog open={!!selectedImage} onOpenChange={() => setSelectedImage(null)}>
                <DialogContent className="max-w-4xl p-0 bg-transparent border-none">
                    <button 
                        onClick={() => setSelectedImage(null)}
                        className="absolute top-4 right-4 z-50 p-2 bg-foreground/80 text-background rounded-full hover:bg-foreground transition-colors"
                    >
                        <X className="w-5 h-5" />
                    </button>
                    {selectedImage && (
                        <img 
                            src={selectedImage.src}
                            alt={selectedImage.alt}
                            className="w-full h-auto max-h-[80vh] object-contain rounded-lg"
                        />
                    )}
                </DialogContent>
            </Dialog>
        </section>
    );
};

export default Gallery;
